import type { DeepReadonly, ToRefs } from 'vue'
import { reactive, readonly, toRefs } from 'vue'

type State = {
  visible: boolean
  isItemActive: boolean
}

export type UseConfigToggle = {
  toggleVisibility: () => void
  toggleItem: () => void
  elementRef: Ref<HTMLElement | undefined>
} & ToRefs<DeepReadonly<State>>

export function useConfigToggle(onToggleVisibility?: () => void): UseConfigToggle {
  const state = reactive<State>({
    visible: true,
    isItemActive: false,
  })

  const elementRef = ref<HTMLElement | undefined>()

  useClickOutside([elementRef], ref(false), () => {
    state.isItemActive = false
  })

  function toggleVisibility() {
    state.visible = !state.visible
    onToggleVisibility?.()
  }

  function toggleItem() {
    state.isItemActive = !state.isItemActive
  }

  return {
    ...toRefs(readonly(state)),
    elementRef,
    toggleVisibility,
    toggleItem,
  }
}
